var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bar"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"ml-1 pt-0",attrs:{"cols":"12"}},[_c('span',{staticClass:"action-text"},[_vm._v(_vm._s(_vm.text))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }